import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-web-design',
  templateUrl: './web-design.component.html',
  styleUrls: ['./web-design.component.css'],
})
export class WebDesignComponent {
  constructor(private titleService: Title, private metaTagService: Meta) {}

  ngOnInit() {
    // Meta Title , Description , keywords
    this.titleService.setTitle('Web Design Company in Dubai | Pro Web');
    this.metaTagService.updateTag({
      name: 'description',
      content:
        'Pro Web Dubai excels in web design, prioritizing innovation and effectiveness. Our skilled team crafts exceptional product designs, combining creativity and technology for impactful brand showcases.',
    });
    this.metaTagService.updateTag({
      name: 'keywords',
      content:
        'web design services, web design services dubai, web design company, web design company dubai',
    });
  }

  processdata = [
    {
      icon: '/assets/img/servicesdev/process-way/analysis-orange.png',
      heading: 'Analysis and Planning',
      description:
        'Through thorough research and analysis, we meticulously gather comprehensive information on market trends and target audiences. This information forms the foundation for our precise planning, where we strategically determine the technologies and tools required for project execution. Additionally, we define the website layout and modules, ensuring a well-thought-out framework for the development of a feasible website.',
    },

    {
      icon: '/assets/img/servicesdev/process-way/design-orange.png',
      heading: 'Design & Development',
      description:
        "During the design phase, our focus is on wireframing and creating user interfaces that align with the specific requirements of our clients. Our development process is guided by a keen awareness of online market trends, aiming to captivate the audience's attention through thoughtful design and functionality. We strive to create websites that not only meet but exceed customer expectations.",
    },

    {
      icon: '/assets/img/servicesdev/process-way/quality-orange.png',
      heading: 'Quality Analysis ',
      description:
        'Our dedicated Quality Assurance (QA) team conducts continuous testing to guarantee that the websites are devoid of technical errors, critical bugs, and other code-related issues. This rigorous testing process ensures that the developed applications seamlessly serve their intended purpose, delivering a reliable and user-friendly experience.',
    },
    {
      icon: '/assets/img/servicesdev/process-way/deploy-orange.png',
      heading: 'Deployment',
      description:
        'Upon successful resolution of all technical issues identified during the QA phase, we proceed to launch the websites on online platforms. This deployment phase marks the transition from development to the live environment. Throughout this stage, we actively monitor the websites, gaining insights into user interactions and making any necessary adjustments to optimize performance and user experience.',
    },
  ];

  carouselConfig = {
    autoplay: false,
    autoplaySpeed: 0,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: true,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  cardsItems = [
    {
      title: 'HTML',
      desc: 'From crafting single-page applications to seamlessly integrating HTML into expansive web ecosystems, our experts at Pro Web provide tailored solutions to meet your distinctive needs. Propel your digital presence forward with our HTML services, where form meets function. We prioritize responsive design and ensure cross-browser compatibility, ensuring your web applications not only captivate but also engage users effectively.',
      img: 'assets/img/servicesdev/globe.webp',
    },
    {
      title: 'React.js',
      desc: 'From building single-page applications to integrating React into larger web ecosystems, our experts at Pro Web deliver solutions tailored to your unique requirements. Stay ahead in the competitive digital landscape with our React services, where innovation meets functionality, creating web applications that captivate and engage users because we understand the importance of responsive design and cross-browser compatibility.',
      img: 'assets/img/servicesdev/globe.webp',
    },
    {
      title: 'Vue.js',
      desc: 'Vue.js is a cutting-edge JavaScript framework that offers developers a versatile and efficient platform for building interactive and responsive web applications. With its simplicity and extensive features, Vue.js is the perfect solution for businesses seeking to create engaging and highly functional web applications. At Pro Web, our skilled Vue.js developers are ready to collaborate with you to craft visually appealing and seamlessly performing web applications. Rest assured, with our expertise, your web applications will excel in the ever-evolving online landscape.',
      img: 'assets/img/servicesdev/globe.webp',
    },
    {
      title: 'Angular',
      desc: 'Angular, a robust and comprehensive JavaScript framework, is a powerful tool for developing dynamic and feature-rich web applications. With its strong architecture and a wide range of libraries and tools, Angular is the ideal choice for businesses aiming to create complex, scalable, and high-performance web applications. At Pro Web, our dedicated Angular developers are ready to work with you to craft cutting-edge web applications that not only look exceptional but also deliver superior user experiences. Your web applications will thrive online with our expertise.',
      img: 'assets/img/servicesdev/globe.webp',
    },
  ];

  processModelData = [
    {
      heading: 'Analysis and Planning',
      description:
        'Through thorough research and analysis, we meticulously gather comprehensive information on market trends and target audiences. This information forms the foundation for our precise planning, where we strategically determine the technologies and tools required for project execution. Additionally, we define the website layout and modules, ensuring a well-thought-out framework for the development of a feasible website.',
      icon: '',
    },
  ];

  logo = [
    '/assets/img/servicesdev/web-design/whites.webp',
    '/assets/img/servicesdev/web-design/x-cloud.svg',
    '/assets/img/servicesdev/web-design/neo_realty_logo.svg',
    '/assets/img/servicesdev/web-design/the_bezel_club_logo.svg',
  ];

  logo2 = [
    '/assets/img/servicesdev/web-design/whites.webp',
    '/assets/img/servicesdev/web-design/x-cloud.svg',
    '/assets/img/servicesdev/web-design/sea7-beauty.svg',
  ];

  taglinearr = [
    'Top Rated Web Agency',
    'Digital Design Experts',
    'Quality Web Design',
    'Innovative Designs',
    'Top Rated Web Agency',
    'Digital Design Experts',
    'Quality Web Design',
    'Innovative Designs',
  ];

  portfolioItems = [
    {
      heading: 'The Bezel Club',
      smalltitle: 'Luxury Watch Website',
      desc: 'The Bezel Club website has left an indelible mark on its audience, emerging as a premium hub for passionate watch enthusiasts. Its dedication to curating user experiences within the realm of luxury timepieces has cultivated a community where collectors can proudly showcase their prized possessions.',
      bgimg: '../../assets/img/servicesdev/bezel.webp',
      icon: '../../assets/img/servicesdev/web-design/vue-js.svg',
      casestudy: 'case-study/the-bezel-club',
      heading1: 'Specialists Worked',
      heading2: 'Retention Rate',
      heading3: 'Years of Business',
      specialist: '4',
      download: '96%',
      rating: '2+',
    },
    {
      heading: 'Whites',
      smalltitle: 'dry-cleaning and laundry Website',
      desc: 'Whites provides advanced laundry services with a state-of-the-art home-delivery system, specializing in premium dry-cleaning and delicate garment care. Their contemporary services are designed to ensure a pleasant experience with exclusive care for precious wear. In addition to their expertise in high-end textile care.',
      bgimg: '../../assets/img/servicesdev/whites.webp',
      icon: '../../assets/img/servicesdev/web-design/laravel2.svg',
      casestudy: '',
      heading1: 'Specialists Worked',
      heading2: 'Retention Rate',
      heading3: 'Years of Business',
      specialist: '3',
      download: '84%',
      rating: '5+',
    },
    {
      heading: 'XCloud',
      smalltitle: 'Managed IT Services',
      desc: 'XCLOUD, established in 2020 as a subsidiary of XSAT Telephones & Telecommunications Equipment Trading LLC, is a leading Managed Service Provider. Our expertise spans from design and development to curating the service cost calculator, resulting in a platform where IT services have become the go-to place for those seeking them.',
      bgimg: '../../assets/img/servicesdev/xcloud.webp',
      icon: '../../assets/img/servicesdev/web-design/react-js.svg',
      casestudy: '',
      heading1: 'Specialists Worked',
      heading2: 'Retention Rate',
      heading3: 'Years of Business',
      specialist: '4',
      download: '87%',
      rating: '3+',
    },
    {
      heading: 'Neo Realty',
      smalltitle: 'Real Estate',
      desc: " Neo Realty is a distinctive brokerage firm that goes beyond expectations, offering an extraordinary journey while assisting clients in exploring Dubai's finest commercial and residential properties. With a commitment to delivering exceptional service and expert guidance, Neo Realty aims to support individuals on their unique ventures within the dynamic realm of Dubai's real estate market.",
      bgimg: '../../assets/img/servicesdev/neoreality.webp',
      icon: '../../assets/img/servicesdev/web-design/wordpress.svg',
      casestudy: '',
      heading1: 'Specialists Worked',
      heading2: 'Retention Rate',
      heading3: 'Years of Business',
      specialist: '3',
      download: '89%',
      rating: '4+',
    },

    // {
    //   heading: "Sea7Beauty",
    //   smalltitle: "Beauty Salon & Spa Website",
    //   desc: "Sea7beauty is dedicated to providing top-notch salon services with a team of skilled beauticians and premium products. They bring a range of services, including foot reflexology, manicures, pedicures, body scrubs, bleaching, hair care, Thai massage, and more, all within the vibrant city of Dubai.",
    //   bgimg: "../../assets/img/servicesdev/sea7.webp",
    //   icon: "../../assets/img/servicesdev/php.svg",
    //   casestudy: "",
    //   heading1: 'Specialists Worked',
    //   heading2: 'Retention Rate',
    //   heading3: 'Years of Business',
    //   specialist: "3",
    //   download: "89%",
    //   rating: "4+"
    // },
  ];

  data = [
    'whites2-logo.webp',
    'X_CLOUD_LOGO_white.svg',
    'The_travel_hub_logo.svg',
    'alliance_international_logo.svg',
    'neo_realty_logo.svg',
  ];

  datamobile = [
    'whites2-logo.webp',
    'X_CLOUD_LOGO_white.svg',
    'alliance_international_logo.svg',
    'neo_realty_logo.svg',
  ];

  faq = [
    {
      title: 'What is web design?',
      des: '<p> Web design is the process of creating and arranging elements on a website, including layout, graphics, colors, fonts, and interactive features. It aims to enhance user experience and deliver visually appealing, effective, and functional websites.</p>',
      isActive: false,
    },
    {
      title:
        'Why is responsive design important and how does it contribute to mobile optimization?',
      des: '<p>Responsive design is vital for a positive user experience on various devices. It ensures mobile optimization by adapting layouts, enhancing accessibility, and accommodating different screen sizes, improving overall usability and satisfaction.</p>',
      isActive: false,
    },
    {
      title:
        'Do you provide UI/UX design services only from scratch? Can you do an existing app/web redesign?',
      des: "<p> Absolutely! We offer both UI/UX design for new projects and redesign services for existing app/web. Whether it's a fresh concept or enhancing an established platform, our team is adept at transforming user experiences to meet your specific needs and goals.</p>",
      isActive: false,
    },
    {
      title: 'Do you redesign websites along with making them responsive ?',
      des: '<p>Yes, we offer comprehensive website redesign services, ensuring responsiveness for optimal user experience. Our approach focuses on modernizing aesthetics and functionality to align with evolving design trends and user expectations.</p>',
      isActive: false,
    },
    {
      title:
        'Can you redesign my website to align with my brand guidelines and incorporate my logo?',
      des: "<p> Upon receiving your logo and brand guidelines, we're ready to redesign your websites. We'll create mobile/desktop mockups, and the implementation will commence once you approve the proposed design.</p>",
      isActive: false,
    },
    {
      title: 'What web technologies do you utilize for web design?',
      des: '<p>We leverage a range of web technologies for design, including Vue.js, Angular, HTML, WordPress,  Drupal etc. These tools empower us to create dynamic, responsive, and visually appealing websites tailored to your requirements.</p>',
      isActive: false,
    },
    {
      title:
        'Which applications/software are part of your toolkit for creating mockups?',
      des: '<p> The tools we use for creating mockups include industry-standard software such as Figma, Sketch, Photoshop, Adobe Illustrator etc. These tools enable us to design and visualize user interfaces effectively during the early stages of the web design process.</p>',
      isActive: false,
    },
    {
      title: 'How much does a custom web design project typically cost?',
      des: '<p>Custom web design projects generally range from 10,000 to 30,000 AED, reflecting the complexity of pages and design mockups. Theme-based options offer a more affordable choice, ranging from 4,000 to 10,000 AED, based on the number of pages involved.</p>',
      isActive: false,
    },
  ];

  toggleAccordian(event: any, index: any) {
    this.faq.forEach((item, i) => {
      if (i !== index) {
        item.isActive = false;
      }
    });

    // Toggle the clicked item
    this.faq[index].isActive = !this.faq[index].isActive;
  }

  designStr: string =
    '<h3 class="my-3">Optimizing Affordability and User-Friendly Design</h3> <p>Well-considered UI/UX design plays a pivotal role in enhancing user engagement and guiding them towards desired actions, whether it is for applications, websites, or various digital resources. Through initial research and a thorough analysis of business requirements, UI/UX design can significantly reduce the need for costly post-release modifications. The primary objective of user experience consulting is to create a roadmap of the users journey, delve into user emotions, and proactively address any potential obstacles that may hinder a smooth user experience. These advantages of UI/UX design services are applicable across the board, whether it is a straightforward fitness application, a landing page, or embedded software.</p> <p>At Pro Web, we offer dedicated UI/UX design services while seamlessly integrating UI/UX best practices into every stage of software development. Our approach revolves around placing the user at the center of the design process, ensuring that design choices are informed by their specific needs and preferences. This alignment allows us to harmonize the visual and interactive aspects of the product with our clients overarching business objectives. The Pro Web design team is well-versed in the latest UI/UX guidelines and possesses expertise in fundamental mobile and web UI technologies.</h4> <h5 class="my-3">The Exceptional Qualities of Our Design</h5> <p>We do not follow common trends; instead, we innovate from the ground up, crafting unique ideas. Our web design services will give you a competitive edge.</p> <h5>Delivering User-Friendly Design For Enhanced Interaction </h5> <p>At Pro Web , we have a team of skilled UI/UX designers who excel at creating highly immersive and impactful digital products. Our approach involves a deep dive into your business and the specific audience you are targeting. We are committed to crafting meaningful and exceptional web design for businesses in the UAE.</p> <p>We excel in creating UI/UX designs in Dubai that exceed industry expectations, offering a superb and enhanced customer interaction experience. Every detail we incorporate is carefully chosen to enhance your business credibility. Whether it is mobile app design or website UI design, we cover it all.</p> <h5>Tailored UI/UX Solutions in Dubai for Boosting Your Brand </h5> <p>Our solutions are finely tuned to meet the demands of the web design market in Dubai. Our designers leverage a scientific understanding of the human-centered approach to design, ensuring a perfect outcome for user interface design projects.</p> <p>We have extensive expertise in a wide range of industries and we tailor our approach to align with the preferences of your target audience. </p> <h3>Our Transparent Creative Process </h3> <p>As a trusted web design company in Dubai, we prioritize transparency with our clients. Our user experience design process follows a structured and straightforward path:</p> <ul> <li>Our UI developer gathers essential requirements, including business personas, client objectives, case study analysis, user pain points, business goals, and industry best practices.</li> <li>Our experts conduct equity and competitor analysis, identifying areas of opportunity. We also conduct a thorough audit of your website to eliminate weaknesses.</li> <li>We develop an information architecture, map the user experience, and create low-fidelity wireframes and prototypes tailored to your business portfolio.</li> <li>Our professionals define a visual direction, create mood boards, and conceptualize key screens based on a human-centered approach.</li> <li>We perform a motion graphic analysis of interface behavior on different devices, including iconography and illustrations.</li><li>Our final product is delivered with a library of high-quality UI elements, forward recommendations for the development team, and illustrative guidelines.</li></ul> <p>At every step, we ensure that the clients business objectives are met while considering the users perspective. Every aspect of our designs adheres to your business and industry standards. Our services are designed to make you outshine your competition. But our commitment goes beyond that—we also monitor the products performance and provide post-development support to adapt to market changes swiftly.</p>  ';

  cards = [
    {
      icon: '../../assets/img/servicesdev/creativity.svg',
      heading: 'Creativity',
      description:
        'Unparalleled creativity, where innovation & imagination drive extraordinary results.',
    },
    {
      icon: '../../assets/img/servicesdev/teamwork.svg',
      heading: 'Teamwork',
      description:
        'Exceptional teamwork, where collaboration and synergy form the foundation of success',
    },
    {
      icon: '../../assets/img/servicesdev/innovation.svg',
      heading: 'Realtime monitoring',
      description:
        'Urge to innovate, where we consistently push boundaries, fostering creative thinking.',
    },
    {
      icon: '../../assets/img/servicesdev/quality.svg',
      heading: 'Quality',
      description:
        'Commitment to quality, where excellence is the standard, ensuring every deliverable meets the benchmark',
    },
    {
      icon: '../../assets/img/servicesdev/security.svg',
      heading: 'Security',
      description:
        'Security, where safeguarding the assets and data is our utmost priority, backed by advanced technologies.',
    },
    {
      icon: '../../assets/img/servicesdev/trust.svg',
      heading: 'Trust',
      description:
        'We inspire, built on transparency, honesty, and a track record of delivering on our commitments',
    },
  ];
}
